export const ENVIRONMENT_OPTIONS = [
    {
        name: "Extreme Heat",
        price: 1.2
    },
    {
        name: "Extreme Cold",
        price: 2.0
    },
    {
        name: "Rain/Snow",
        price: 2.5
    },
    {
        name: "Icy/Slippery Surfaces",
        price: 3.0
    },
    {
        name: "Poor Lighting",
        price: 3.5
    },
    {
        name: "Night Work",
        price: 3.0
    }
];